import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress TinyMCE onboarding plugin's domain-validation errors so they don't
// break the React dev error overlay or pollute the console in preview.
// Production (aligcus.com) is whitelisted in the TinyMCE Customer Portal.
const isTinyMceOnboardingError = (msg) =>
  typeof msg === 'string' && (
    msg.includes('body stream already read') ||
    msg.includes('tiny.cloud') ||
    msg.includes('invalid-origin')
  );

window.addEventListener('unhandledrejection', (e) => {
  const msg = e.reason?.message || e.reason?.toString?.() || '';
  if (isTinyMceOnboardingError(msg)) e.preventDefault();
});
window.addEventListener('error', (e) => {
  const src = e.filename || '';
  if (src.includes('tiny.cloud') || isTinyMceOnboardingError(e.message || '')) {
    e.preventDefault();
  }
});

// Dev-only: webpack-dev-server's full-screen error overlay is triggered by
// TinyMCE's onboarding plugin runtime error (which we can't modify). Quietly
// remove the overlay iframe so the admin UI stays usable in preview.
if (process.env.NODE_ENV === 'development' && typeof MutationObserver !== 'undefined') {
  const removeOverlay = () => {
    document.getElementById('webpack-dev-server-client-overlay')?.remove();
  };
  const startObserver = () => {
    const root = document.body || document.documentElement;
    if (!root) return;
    new MutationObserver(removeOverlay).observe(root, { childList: true });
    removeOverlay();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
